import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ListLayout from "../../components/common/List/Custom-List_layout";
// import { useGetMemberlistQuery } from "../../../store/api/member"
import { useDeleteMemberMutation } from "../../store/api/member";
import { useGetCheckInLogsQuery } from "../../store/api/member";
import Convertdate from "../../components/common/List/Converdate";
import ConfirmationModal from "../../components/common/List/DeletePopup";

const FytBotAttendeceList = () => {
  const permissionname = 'member'
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [filterValues, setFilterValues] = useState({});
  const [sortKey, setSortKey] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [deleteMember] = useDeleteMemberMutation();
  const { data: tabledata, isLoading, refetch } = useGetCheckInLogsQuery({
    page: currentPage,
    page_size: pageSize,
    sort: sortKey,
    ...filterValues,
  });

  const handleDelete = async () => {
    try {
      await deleteMember(deleteid.id);
      setIsModalOpen(false);
      refetch()
    } catch (error) {
      refetch();
    }
  };

  const handleSort = (key) => {


    const cleanKey = key.split(".").pop();

    if (sortKey !== cleanKey) {
      setSortKey(cleanKey);
    }
  };


  const renderAttendanceStatus = (value) => {
    let bgColor = "bg-gray-500"; // default

    if (value === "Present") bgColor = "bg-green-500";
    else if (value === "Absent") bgColor = "bg-red-500";
    else if (value === "Plan Expired") bgColor = "bg-orange-500";

    return (
      <span className={`px-4 py-2 rounded-full text-white font-semibold ${bgColor}`}>
        {value}
      </span>
    );
  };

const tableHeaders = [
  { label: "S.NO", key: "serial_no", increameant: true, placeholder: "S.NO" },
  { label: "Name", key: "user_name", sortable: true },
  { label: "Appointment Time", key: "appointment_time", sortable: true },
  { label: "Check-In Time", key: "checkin_time", formatter: Convertdate, sortable: true },
];




  useEffect(() => {
    refetch()

  }, [])

const filters = [
  { key: "user_name", type: "text", placeholder: "Name" },
  { key: "checkin_time", type: "date", placeholder: "Check-In Date" },
];


  const filterComponents = filters.map((filter) => ({
    ...filter,
    value: filterValues[filter.key] || "",
  }));

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
  };

  const actionButtons = [
    {
      icon: "MdOutlineRemoveRedEye",
      onClick: (row) => navigate("/member-view", { state: { data: row, pageName: "Member" } }),
    },
    {
      icon: "MdOutlineModeEdit",
      onClick: (row) => {
        navigate("/edit-member", { state: { data: row, pageName: "Member" } });
      },
    },

    {
      icon: "RiDeleteBinLine",
      onClick: (row) => {
        setdeleteid(row);
        setIsModalOpen(true);
      },
    },
  ];

  const Buttons = [
   
  ];

  return (
    <>
      <ListLayout
        title="FytBot Attendece Log"
        Buttons={Buttons}
        permissionname={permissionname}
        filterComponents={filterComponents}
        onFilterChange={handleFilterChange}
        tableHeaders={tableHeaders}
        tabledata={tabledata?.data}
        actionButtons={actionButtons}
        currentPage={currentPage}
        totalrecords={tabledata?.count}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSort={handleSort}
        sortKey={sortKey}
        isLoading={isLoading}
      />
      {isModalOpen && (
        <ConfirmationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
};

export default FytBotAttendeceList;
